/** Код палета «SWP-<партия>-<палет>» (ADR-0011) — как `backend/app/domain/pallets.py`. */
const CODE = /^SWP-(\d{1,18})-(\d{1,3})$/;

export interface PalletRef {
  batchId: number;
  palletNo: number;
}

/** Разобрать код со сканера или из ссылки; null — это не код палета. */
export function parsePalletCode(raw: string): PalletRef | null {
  const m = CODE.exec(raw.trim().toUpperCase());
  if (!m?.[1] || !m[2]) return null;
  const batchId = Number(m[1]);
  const palletNo = Number(m[2]);
  return batchId > 0 && palletNo >= 1 && palletNo <= 999 ? { batchId, palletNo } : null;
}
